export enum WeeklyOverviewTenseEnum {
  PAST = 'past',
  PRESENT = 'present',
  MISSING_CHECKOUT = 'missing-checkout',
  NOT_SPECIFIED = 'not-specified',
}
